import React from 'react';

const KpiTile = ({ label, value, subLabel, accentColor = '#2563eb' }) => (
  <div style={{
    backgroundColor: '#fff', borderRadius: 5, padding: '7px 10px',
    border: '1px solid #d1d5db',
    boxShadow: '0 1px 2px rgba(0,0,0,.06),0 1px 3px rgba(0,0,0,.08)',
    minWidth: 0, flex: 1, position: 'relative', overflow: 'hidden', flexShrink: 0,
  }}>
    <div style={{
      position: 'absolute', left: 0, top: 0, bottom: 0, width: 3,
      backgroundColor: accentColor, borderRadius: '2px 0 0 2px',
    }} />
    <div style={{
      fontSize: 8, fontWeight: 700, textTransform: 'uppercase',
      letterSpacing: 0.4, color: '#9ca3af', marginBottom: 2,
    }}>
      {label}
    </div>
    <div style={{
      fontSize: 17, fontWeight: 700, color: '#1a3353', lineHeight: 1.1,
      fontFamily: "'JetBrains Mono', monospace",
    }}>
      {value}
    </div>
    {subLabel && (
      <div style={{ fontSize: 8, color: '#9ca3af', marginTop: 1 }}>
        {subLabel}
      </div>
    )}
  </div>
);

export default KpiTile;
